import { c as b } from "react/compiler-runtime";
import { useState as S, useEffect as E } from "react";
const d = window.SpeechRecognition || window.webkitSpeechRecognition;
class l {
  recognition;
  listening = !1;
  static isSupported() {
    return !!d;
  }
  constructor(n = "en-US") {
    if (!d)
      throw new Error("Speech recognition is not supported in this browser");
    this.recognition = new d(), this.recognition.lang = n;
  }
  start() {
    if (!l.isSupported()) {
      console.error("Speech recognition is not supported in this browser");
      return;
    }
    this.listening = !0, this.recognition.start();
  }
  onStart(n) {
    this.listening = !0, this.recognition.onaudiostart = n;
  }
  onEnd(n) {
    this.listening = !1, this.recognition.onaudioend = n;
  }
  onError(n) {
    this.recognition.onerror = (e) => {
      n(e.error);
    };
  }
  stop() {
    this.recognition.stop(), this.listening = !1;
  }
  onResult(n) {
    this.recognition.onresult = (e) => {
      console.log(e.results);
      const o = e.results[e.results.length - 1][0].transcript;
      this.listening = !1, n(o);
    };
  }
}
const i = l.isSupported() ? new l() : null, T = () => {
  const t = b(8), [n, e] = S(null), [o, h] = S(i?.listening), [f, s] = S(null);
  let c, u;
  t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = () => {
    if (!l.isSupported()) {
      s("Speech recognition is not supported in this browser");
      return;
    }
    i?.onStart(() => {
      s(null), e(null), h(!0);
    }), i?.onResult((r) => {
      e(r), s(null);
    }), i?.onError((r) => {
      s(r), e(null), h(!1);
    }), i?.onEnd(() => {
      s(null), e(null), h(!1);
    });
  }, u = [], t[0] = c, t[1] = u) : (c = t[0], u = t[1]), E(c, u);
  let g;
  t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (g = function() {
    i?.start();
  }, t[2] = g) : g = t[2];
  const m = g;
  let p;
  t[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = function() {
    i?.stop();
  }, t[3] = p) : p = t[3];
  const w = p;
  let a;
  return t[4] !== f || t[5] !== o || t[6] !== n ? (a = {
    transcript: n,
    error: f,
    startListening: m,
    stopListening: w,
    isListening: o
  }, t[4] = f, t[5] = o, t[6] = n, t[7] = a) : a = t[7], a;
};
export {
  T as useSpeechToText
};
